import Backdrop from "../base/Backdrop.js";

/**
 * Backdrop component in the Plain reference design system
 *
 * @inherits Backdrop
 */
class PlainBackdrop extends Backdrop {}

export default PlainBackdrop;
